import styled from 'styled-components';

export const Imagem = styled.img`
  padding: 5px;
  margin: auto;
  width: 30vw;
`;

export const Page = styled.div`
  height: 90vh;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  text-align: center;
`;

export const DivImage = styled.div`
  margin: auto;
`;

export const DivText = styled.div`
  max-width: 100rem;
  margin: auto;

  h1 {
    font-size: 80pt;
    font-weight: 600;
    color: var(--primary-color-sefaz);
    margin: 0;
    height: 12rem;
  }
  h2 {
    font-size: 25pt;
    font-weight: 500;
    color: var(--primary-color-sefaz);
    margin: 0;
    margin-bottom: 20px;
  }
  p {
    text-align: justify;
    margin: auto;
    width: 80%;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 13px;
  justify-content: center;
  margin-top: 20px;
`;
